export default __webpack_public_path__ + "static/media/img_blanketBunny_beige_p.14a86d3e.jpg";